import { REQUEST } from 'crom-api-constants'

export const LOG_ACTION = 'LOG_ACTION'
export const LOG_ACTION_REQUEST = `LOG_ACTION_${REQUEST}`

export const ACTION_CD = {
    UPSELL_CLICK: 'UPSELL_CLICK',
}

export const MODULE_CD = {
    HOME: 'HOME',
    REPORT: 'REPO',
    LINKAGES: 'LIAN',
    PORTFOLIO: 'PORT',
}
